<template>
  <div class="report-list-container">
    <!-- 查询表单 -->
    <el-card class="search-card">
      <template #header>
        <div class="card-header">
          <span>查询条件</span>
          <el-button type="text" @click="toggleSearchForm">
            {{ showSearchForm ? '收起' : '展开' }}
          </el-button>
        </div>
      </template>
      
      <el-collapse-transition>
        <div v-show="showSearchForm" class="search-form">
          <el-form :model="searchForm" :inline="!isMobile" class="responsive-form">
            <el-form-item label="样品名称">
              <el-input 
                v-model="searchForm.sampleName" 
                placeholder="请输入样品名称"
                clearable
                @clear="handleSearch"
                @keyup.enter="handleSearch"
              ></el-input>
            </el-form-item>
            <el-form-item label="报告编号">
              <el-input 
                v-model="searchForm.sampleNumber" 
                placeholder="请输入报告编号"
                clearable
                @clear="handleSearch"
                @keyup.enter="handleSearch"
              ></el-input>
            </el-form-item>
         
            <!-- <el-form-item label="样品状态">
              <el-input 
                v-model="searchForm.sampleStatus" 
                placeholder="请输入样品状态"
                clearable
                @clear="handleSearch"
                @keyup.enter="handleSearch"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="委托单位">
              <el-input 
                v-model="searchForm.clientUnit" 
                placeholder="请输入委托单位"
                clearable
                @clear="handleSearch"
                @keyup.enter="handleSearch"
              ></el-input>
            </el-form-item>
            <el-form-item label="合作公司">
              <el-input 
                v-model="searchForm.partnerCompany" 
                placeholder="请输入合作公司"
                clearable
                @clear="handleSearch"
                @keyup.enter="handleSearch"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传时间">
              <el-date-picker
                v-model="searchForm.uploadDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                @change="handleSearch"
                :size="isMobile ? 'small' : 'default'"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="form-actions">
              <el-button type="primary" @click="searchReports" :size="isMobile ? 'small' : 'default'">查询</el-button>
              <el-button @click="resetSearch" :size="isMobile ? 'small' : 'default'">重置</el-button>
              <el-button type="info" @click="refreshReports" :loading="loading" :size="isMobile ? 'small' : 'default'">刷新</el-button>
              <el-button v-if="isDesktop" type="success" @click="exportData" :size="isMobile ? 'small' : 'default'">导出数据</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </el-card>

    <el-card>
      <template #header>
        <div class="card-header">
          <span>报告管理</span>
          <div class="header-actions">
            <el-button type="primary" @click="showUploadDialog = true" :size="isMobile ? 'small' : 'default'">上传报告</el-button>
            <el-switch
              v-model="showDownloadButton"
              active-text="显示下载按钮"
              inactive-text="隐藏下载按钮"
              @change="handleDownloadButtonVisibilityChange"
              style="margin-left: 15px;"
            ></el-switch>
            <!-- <el-button v-if="isMobile" type="success" @click="exportData" :size="isMobile ? 'small' : 'default'">导出</el-button> -->
          </div>
        </div>
      </template>
      
      <!-- 桌面端表格 -->
      <el-table v-if="isDesktop" :data="displayReports" style="width: 100%" v-loading="loading" stripe>
        <el-table-column prop="sampleName" label="样品名称" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sampleNumber" label="报告编号" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="inspectionStatus" label="检验状态" width="100">
          <template #default="scope">
            <el-tag :type="getStatusType(scope.row.inspectionStatus)">
              {{ scope.row.inspectionStatus || '待检验' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="inspectionType" label="检验类型" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sampleStatus" label="样品状态" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="clientUnit" label="委托单位" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="inspectedUnit" label="受检单位" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="manufacturerUnit" label="生产单位" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="completionDeadline" label="完成期限" width="120">
          <template #default="scope">
            {{ formatDeadline(scope.row.completionDeadline) }}
          </template>
        </el-table-column>
        <el-table-column prop="partnerCompany" label="合作公司" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="uploadTime" label="上传时间" width="180">
          <template #default="scope">
            {{ formatUploadTime(scope.row.uploadTime) }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="产品报告" width="120">
          <template #default="scope">
            <el-button type="text" @click="viewReport(scope.row.id)" size="small">
              {{ scope.row.fileName }}
            </el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="400" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="editReport(scope.row)">编辑</el-button>
            <el-button type="success" size="small" @click="uploadAttachment(scope.row)">报告上传</el-button>
            <el-button type="warning" size="small" @click="generateQRCode(scope.row)">生成二维码</el-button>
            <el-button type="danger" size="small" @click="deleteReport(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- PC端分页 -->
      <div v-if="isDesktop && total > 0" class="pagination-container">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handlePageSizeChange"
          @current-change="handlePageChange"
        />
      </div>
      
      <!-- 移动端卡片布局 -->
      <div v-if="isMobile" class="mobile-card-list" v-loading="loading">
        <div v-for="report in displayReports" :key="report.id" class="report-card">
          <div class="card-header-mobile">
            <div class="report-title">
              <h3>{{ report.sampleName }}</h3>
              <span class="sample-number">{{ report.sampleNumber }}</span>
            </div>
            <el-tag :type="getStatusType(report.inspectionStatus)" size="small">
              {{ report.inspectionStatus || '待检验' }}
            </el-tag>
          </div>
          
          <div class="card-content">
            <div class="info-row" v-if="report.inspectionType">
              <span class="label">检验类型:</span>
              <span class="value">{{ report.inspectionType }}</span>
            </div>
            <div class="info-row" v-if="report.sampleStatus">
              <span class="label">样品状态:</span>
              <span class="value">{{ report.sampleStatus }}</span>
            </div>
            <div class="info-row" v-if="report.clientUnit">
              <span class="label">委托单位:</span>
              <span class="value">{{ report.clientUnit }}</span>
            </div>
            <div class="info-row" v-if="report.partnerCompany">
              <span class="label">合作公司:</span>
              <span class="value">{{ report.partnerCompany }}</span>
            </div>
            <div class="info-row" v-if="report.completionDeadline">
              <span class="label">完成期限:</span>
              <span class="value">{{ formatDeadline(report.completionDeadline) }}</span>
            </div>
            <div class="info-row">
              <span class="label">上传时间:</span>
              <span class="value">{{ formatUploadTime(report.uploadTime) }}</span>
            </div>
          </div>
          
          <div class="card-actions">
            <el-button type="primary" size="small" @click="editReport(report)">编辑</el-button>
            <el-button type="success" size="small" @click="uploadAttachment(report)">上传</el-button>
            <el-button type="warning" size="small" @click="generateQRCode(report)">二维码</el-button>
            <el-button type="danger" size="small" @click="deleteReport(report)">删除</el-button>
          </div>
        </div>
      </div>
      
      <!-- 手机端加载更多按钮 -->
      <div v-if="isMobile && hasMore && displayReports.length > 0" class="load-more-container">
        <el-button @click="loadMore" :loading="loading" type="primary" plain>
          加载更多
        </el-button>
      </div>
      
      <div v-if="displayReports.length === 0 && !loading" class="empty-state">
        <el-empty description="暂无报告数据">
          <el-button type="primary" @click="showUploadDialog = true">上传第一个报告</el-button>
        </el-empty>
      </div>
    </el-card>

    <!-- 新建报告对话框 -->
    <el-dialog v-model="showUploadDialog" title="新建报告" width="600px" :close-on-click-modal="false">
      <el-form :model="uploadForm" :rules="uploadRules" ref="uploadFormRef" label-width="120px">
        <el-form-item label="样品名称" prop="sampleName" required>
          <el-input v-model="uploadForm.sampleName" placeholder="请输入样品名称"></el-input>
        </el-form-item>
        <el-form-item label="报告编号" prop="sampleNumber" required>
          <el-input v-model="uploadForm.sampleNumber" placeholder="请输入报告编号"></el-input>
        </el-form-item>
        <el-form-item label="检验状态" prop="inspectionStatus">
          <el-select v-model="uploadForm.inspectionStatus" placeholder="请选择检验状态">
            <el-option label="待检验" value="待检验"></el-option>
            <el-option label="检验中" value="检验中"></el-option>
            <el-option label="已完成" value="已完成"></el-option>
            <el-option label="已取消" value="已取消"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检验类型" prop="inspectionType">
          <el-input v-model="uploadForm.inspectionType" placeholder="请输入检验类型"></el-input>
        </el-form-item>
        <el-form-item label="样品状态" prop="sampleStatus">
          <el-input v-model="uploadForm.sampleStatus" placeholder="请输入样品状态"></el-input>
        </el-form-item>
        <el-form-item label="委托单位" prop="clientUnit">
          <el-input v-model="uploadForm.clientUnit" placeholder="请输入委托单位"></el-input>
        </el-form-item>
        <el-form-item label="受检单位" prop="inspectedUnit">
          <el-input v-model="uploadForm.inspectedUnit" placeholder="请输入受检单位"></el-input>
        </el-form-item>
        <el-form-item label="生产单位" prop="manufacturerUnit">
          <el-input v-model="uploadForm.manufacturerUnit" placeholder="请输入生产单位"></el-input>
        </el-form-item>
        <el-form-item label="完成期限" prop="completionDeadline">
          <el-date-picker
            v-model="uploadForm.completionDeadline"
            type="date"
            placeholder="请选择完成期限"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="合作公司" prop="partnerCompany">
          <el-input v-model="uploadForm.partnerCompany" placeholder="请输入合作公司"></el-input>
        </el-form-item>
      </el-form>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelUpload">取消</el-button>
          <el-button type="primary" @click="submitUpload" :loading="uploading">保存</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 编辑报告对话框 -->
    <el-dialog v-model="showEditDialog" title="编辑报告" width="600px" :close-on-click-modal="false">
      <el-form :model="editForm" :rules="uploadRules" ref="editFormRef" label-width="120px">
        <el-form-item label="样品名称" prop="sampleName" required>
          <el-input v-model="editForm.sampleName" placeholder="请输入样品名称"></el-input>
        </el-form-item>
        <el-form-item label="报告编号" prop="sampleNumber" required>
          <el-input v-model="editForm.sampleNumber" placeholder="请输入报告编号"></el-input>
        </el-form-item>
        <el-form-item label="检验状态" prop="inspectionStatus">
          <el-select v-model="editForm.inspectionStatus" placeholder="请选择检验状态">
            <el-option label="待检验" value="待检验"></el-option>
            <el-option label="检验中" value="检验中"></el-option>
            <el-option label="已完成" value="已完成"></el-option>
            <el-option label="已取消" value="已取消"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检验类型" prop="inspectionType">
          <el-input v-model="editForm.inspectionType" placeholder="请输入检验类型"></el-input>
        </el-form-item>
        <el-form-item label="样品状态" prop="sampleStatus">
          <el-input v-model="editForm.sampleStatus" placeholder="请输入样品状态"></el-input>
        </el-form-item>
        <el-form-item label="委托单位" prop="clientUnit">
          <el-input v-model="editForm.clientUnit" placeholder="请输入委托单位"></el-input>
        </el-form-item>
        <el-form-item label="受检单位" prop="inspectedUnit">
          <el-input v-model="editForm.inspectedUnit" placeholder="请输入受检单位"></el-input>
        </el-form-item>
        <el-form-item label="生产单位" prop="manufacturerUnit">
          <el-input v-model="editForm.manufacturerUnit" placeholder="请输入生产单位"></el-input>
        </el-form-item>
        <el-form-item label="完成期限" prop="completionDeadline">
          <el-date-picker
            v-model="editForm.completionDeadline"
            type="date"
            placeholder="请选择完成期限"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="合作公司" prop="partnerCompany">
          <el-input v-model="editForm.partnerCompany" placeholder="请输入合作公司"></el-input>
        </el-form-item>
      </el-form>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelEdit">取消</el-button>
          <el-button type="primary" @click="submitEdit" :loading="editing">保存</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 报告上传对话框 -->
    <el-dialog v-model="showAttachmentDialog" title="报告上传" width="500px" :close-on-click-modal="false">
      <el-form :model="attachmentForm" ref="attachmentFormRef" label-width="120px">
        <el-form-item label="报告文件" prop="attachmentFile" required>
          <el-upload
            ref="attachmentUploadRef"
            :auto-upload="false"
            :limit="1"
            :on-change="handleAttachmentChange"
            :on-remove="handleAttachmentRemove"
            accept=".pdf,.doc,.docx,.txt"
            :show-file-list="true"
          >
            <el-button type="primary">选择报告文件</el-button>
            <template #tip>
              <div class="el-upload__tip">
                支持 PDF、Word、TXT 格式，文件大小不超过 50MB
              </div>
            </template>
          </el-upload>
        </el-form-item>
        
        <!-- 上传进度条 -->
        <el-form-item v-if="uploadingAttachment" label="上传进度">
          <el-progress 
            :percentage="uploadProgress" 
            :status="uploadProgress === 100 ? 'success' : ''"
            :stroke-width="8"
          />
          <div class="upload-status" v-if="uploadProgress < 100">
            正在上传文件...
          </div>
          <div class="upload-status" v-else>
            文件上传完成，正在处理...
          </div>
        </el-form-item>
      </el-form>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelAttachment" :disabled="uploadingAttachment">取消</el-button>
          <el-button 
            type="primary" 
            @click="submitAttachment" 
            :loading="uploadingAttachment"
            :disabled="!attachmentForm.attachmentFile"
          >
            上传
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 生成二维码对话框 -->
    <el-dialog v-model="showQRCodeDialog" title="生成二维码" width="400px" :close-on-click-modal="false">
      <div class="qr-code-container">
        <div class="qr-code-display">
          <canvas ref="qrCodeCanvas" width="200" height="200" :style="{ display: qrCodeData ? 'block' : 'none' }"></canvas>
          <div v-if="!qrCodeData" class="qr-code-loading">
            <el-icon class="is-loading"><Loading /></el-icon>
            <p>正在生成二维码...</p>
          </div>
          <p v-if="qrCodeData" class="qr-code-info">扫描二维码查看报告详情</p>
        </div>
      </div>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showQRCodeDialog = false">关闭</el-button>
          <el-button type="primary" @click="saveQRCode" :disabled="!qrCodeData">保存二维码</el-button>
        </span>
      </template>
    </el-dialog>

    

    <!-- 删除确认对话框 -->
    <el-dialog v-model="showDeleteDialog" title="确认删除" width="400px">
      <p>确定要删除报告 "{{ deleteTarget?.sampleName }}" 吗？</p>
      <p style="color: #f56c6c; font-size: 14px;">此操作不可恢复，请谨慎操作！</p>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showDeleteDialog = false">取消</el-button>
          <el-button type="danger" @click="confirmDeleteReport" :loading="deleting">确认删除</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import { Loading } from '@element-plus/icons-vue'
import { shouldShowMobileLayout, shouldShowDesktopLayout, getDeviceType } from '@/utils/deviceDetect'

export default {
  name: 'ReportList',
  setup() {
    const reports = ref([])
    const filteredReports = ref([])
    const loading = ref(false)
    const showSearchForm = ref(true)

    // 分页相关数据
    const currentPage = ref(1)
    const pageSize = ref(10)
    const total = ref(0)
    const allReports = ref([]) // 存储所有报告数据
    const displayReports = ref([]) // 当前显示的报告数据（PC端分页或手机端累积）

    // 设备类型检测
    const isMobile = ref(shouldShowMobileLayout())
    const isDesktop = ref(shouldShowDesktopLayout())
    const deviceType = ref(getDeviceType())
    const showDownloadButton = ref(true) // 控制下载按钮显示的状态，默认为 true
    
    
    // 在组件挂载时检测设备类型
    // 加载下载按钮显示设置
    const loadDownloadButtonSetting = async () => {
      try {
        console.log('正在加载下载按钮设置...')
        const response = await fetch('/api/settings/download-button', {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Cache-Control': 'no-cache'
          }
        })
        
        if (response.ok) {
          const data = await response.json()
          console.log('获取到的下载按钮设置:', data)
          showDownloadButton.value = data.visible
          console.log('设置下载按钮状态为:', showDownloadButton.value)
        } else {
          console.error('获取下载按钮设置失败:', response.status)
          const text = await response.text()
          console.error('错误详情:', text)
          // 如果获取失败，保持默认值为 true
          showDownloadButton.value = true
          console.log('获取失败，使用默认值:', showDownloadButton.value)
        }
      } catch (error) {
        console.error('加载下载按钮设置失败:', error)
        // 如果加载失败，保持默认值为 true
        showDownloadButton.value = true
        console.log('加载失败，使用默认值:', showDownloadButton.value)
      }
    }

    // 保存下载按钮显示设置
    const handleDownloadButtonVisibilityChange = async (value) => {
      const oldValue = showDownloadButton.value
      try {
        console.log('正在保存下载按钮设置:', value)
        showDownloadButton.value = value // 立即更新 UI
        
        const response = await fetch('/api/settings/download-button', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Cache-Control': 'no-cache'
          },
          body: JSON.stringify({ visible: value })
        })
        
        if (!response.ok) {
          const text = await response.text()
          console.error('保存设置失败:', response.status, text)
          // 恢复之前的状态
          showDownloadButton.value = oldValue
          console.log('恢复到之前的状态:', oldValue)
          ElMessage.error('保存设置失败')
          return
        }
        
        const data = await response.json()
        console.log('保存设置成功:', data)
        ElMessage.success('设置已保存')
        
        // 重新加载设置以确保同步
        await loadDownloadButtonSetting()
      } catch (error) {
        console.error('保存下载按钮设置失败:', error)
        // 恢复之前的状态
        showDownloadButton.value = oldValue
        console.log('恢复到之前的状态:', oldValue)
        ElMessage.error('保存设置失败')
      }
    }

    onMounted(async () => {
      console.log('=== 组件挂载开始 ===')
      isMobile.value = shouldShowMobileLayout()
      isDesktop.value = shouldShowDesktopLayout()
      deviceType.value = getDeviceType()
      console.log('设备类型检测结果:', {
        isMobile: isMobile.value,
        isDesktop: isDesktop.value,
        deviceType: deviceType.value,
        userAgent: navigator.userAgent
      })
      
      // 加载下载按钮显示设置
      try {
        console.log('开始加载下载按钮设置，当前状态:', showDownloadButton.value)
        await loadDownloadButtonSetting()
        console.log('下载按钮设置加载完成，新状态:', showDownloadButton.value)
      } catch (error) {
        console.error('加载下载按钮设置失败:', error)
      }
      
      // 加载报告列表
      await loadReports()
      console.log('=== 组件挂载完成 ===')
    })
    const uploading = ref(false)
    const editing = ref(false)
    const uploadingAttachment = ref(false)
    const uploadProgress = ref(0)
    const deleting = ref(false)
    const showUploadDialog = ref(false)
    const showEditDialog = ref(false)
    const showAttachmentDialog = ref(false)
    const showQRCodeDialog = ref(false)
    const showDeleteDialog = ref(false)
    const deleteTarget = ref(null)
    const qrCodeData = ref(null)
    const uploadFormRef = ref(null)
    const editFormRef = ref(null)
    const attachmentFormRef = ref(null)
    const attachmentUploadRef = ref(null)
    const qrCodeCanvas = ref(null)

    // 上传表单数据
    const uploadForm = ref({
      sampleName: '',
      sampleNumber: '',
      inspectionStatus: '待检验',
      inspectionType: '',
      sampleStatus: '',
      clientUnit: '',
      inspectedUnit: '',
      manufacturerUnit: '',
      completionDeadline: '',
      partnerCompany: ''
    })

    // 编辑表单数据
    const editForm = ref({
      id: '',
      sampleName: '',
      sampleNumber: '',
      inspectionStatus: '',
      inspectionType: '',
      sampleStatus: '',
      clientUnit: '',
      inspectedUnit: '',
      manufacturerUnit: '',
      completionDeadline: '',
      partnerCompany: ''
    })

    // 附件表单数据
    const attachmentForm = ref({
      reportId: '',
      attachmentFile: null
    })

    // 查询表单数据
    const searchForm = ref({
      sampleName: '',
      sampleNumber: '',
      clientUnit: '',
      partnerCompany: '',
      uploadDateRange: []
    })

    // 表单验证规则
    const uploadRules = {
      sampleName: [
        { required: true, message: '请输入样品名称', trigger: 'blur' }
      ],
      sampleNumber: [
        { required: true, message: '请输入报告编号', trigger: 'blur' }
      ]
    }

    const loadReports = async (reset = false) => {
      loading.value = true
      console.log('🔄 开始加载报告列表, reset:', reset)
      
      try {
        // 添加时间戳参数防止浏览器缓存
        const timestamp = new Date().getTime()
        const response = await fetch(`/api/reports?_t=${timestamp}`, {
          cache: 'no-cache',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        })
        if (!response.ok) {
          throw new Error('获取报告列表失败')
        }
        
        const data = await response.json()
        console.log('📊 从API获取到的数据:', data)
        console.log('📋 报告数量:', data.data?.length || 0)
        
        allReports.value = data.data || []
        total.value = allReports.value.length
        
        // 打印每个报告的附件信息
        allReports.value.forEach((report, index) => {
          console.log(`📄 报告 ${index + 1} (${report.sampleName}):`, {
            id: report.id,
            attachment: report.attachment,
            updatedAt: report.updatedAt || report.uploadTime
          })
        })
        
        // 应用搜索过滤
        applyFilters()
        
        // 根据设备类型更新显示数据
        updateDisplayReports(reset)
      } catch (err) {
        console.error('加载报告列表失败:', err)
        ElMessage.error('加载报告列表失败')
      } finally {
        loading.value = false
      }
    }

    // 应用搜索过滤
    const applyFilters = () => {
      let filtered = allReports.value

      if (searchForm.value.sampleName) {
        filtered = filtered.filter(report => 
          report.sampleName && report.sampleName.includes(searchForm.value.sampleName)
        )
      }
      
      if (searchForm.value.sampleNumber) {
        filtered = filtered.filter(report => 
          report.sampleNumber && report.sampleNumber.includes(searchForm.value.sampleNumber)
        )
      }
      
      if (searchForm.value.clientUnit) {
        filtered = filtered.filter(report => 
          report.clientUnit && report.clientUnit.includes(searchForm.value.clientUnit)
        )
      }
      
      if (searchForm.value.partnerCompany) {
        filtered = filtered.filter(report => 
          report.partnerCompany && report.partnerCompany.includes(searchForm.value.partnerCompany)
        )
      }
      
      // 按上传时间范围过滤
      if (searchForm.value.uploadDateRange && searchForm.value.uploadDateRange.length === 2) {
        const [startDate, endDate] = searchForm.value.uploadDateRange
        filtered = filtered.filter(report => {
          if (!report.uploadTime) return false
          const uploadDate = new Date(report.uploadTime)
          const start = new Date(startDate)
          const end = new Date(endDate)
          end.setHours(23, 59, 59, 999) // 设置为当天结束时间
          return uploadDate >= start && uploadDate <= end
        })
      }

      filteredReports.value = filtered
      total.value = filtered.length
    }

    // 更新显示数据
    const updateDisplayReports = (reset = false) => {
      if (isMobile.value) {
        // 手机端：累积加载
        if (reset) {
          currentPage.value = 1
          displayReports.value = filteredReports.value.slice(0, pageSize.value)
        } else {
          // 加载更多
          const startIndex = (currentPage.value - 1) * pageSize.value
          const endIndex = currentPage.value * pageSize.value
          if (reset || currentPage.value === 1) {
            displayReports.value = filteredReports.value.slice(0, endIndex)
          } else {
            displayReports.value = [...displayReports.value, ...filteredReports.value.slice(startIndex, endIndex)]
          }
        }
      } else {
        // PC端：分页显示
        const startIndex = (currentPage.value - 1) * pageSize.value
        const endIndex = startIndex + pageSize.value
        displayReports.value = filteredReports.value.slice(startIndex, endIndex)
      }
    }

    // PC端分页处理
    const handlePageChange = (page) => {
      currentPage.value = page
      updateDisplayReports()
    }

    const handlePageSizeChange = (size) => {
      pageSize.value = size
      currentPage.value = 1
      updateDisplayReports(true)
    }

    // 手机端加载更多
    const loadMore = () => {
      if (displayReports.value.length < filteredReports.value.length) {
        currentPage.value++
        updateDisplayReports()
      }
    }

    // 检查是否还有更多数据
    const hasMore = computed(() => {
      return displayReports.value.length < filteredReports.value.length
    })


    

    const getStatusType = (status) => {
      const statusMap = {
        '待检验': 'info',
        '检验中': 'warning',
        '已完成': 'success',
        '已取消': 'danger'
      }
      return statusMap[status] || 'info'
    }

    const formatDeadline = (deadline) => {
      if (!deadline) return ''
      const date = new Date(deadline)
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    }

    const formatUploadTime = (uploadTime) => {
      if (!uploadTime) return ''
      return new Date(uploadTime).toLocaleString('zh-CN')
    }

    // 查询相关方法
    const toggleSearchForm = () => {
      showSearchForm.value = !showSearchForm.value
    }

    const handleSearch = () => {
      currentPage.value = 1
      applyFilters()
      updateDisplayReports(true)
    }

    const resetSearch = () => {
      searchForm.value = {
        sampleName: '',
        sampleNumber: '',
        clientUnit: '',
        partnerCompany: '',
        uploadDateRange: []
      }
      currentPage.value = 1
      applyFilters()
      updateDisplayReports(true)
    }

    // 搜索方法
    const searchReports = () => {
      currentPage.value = 1
      applyFilters()
      updateDisplayReports(true)
    }

    // 新建报告相关方法
    const cancelUpload = () => {
      showUploadDialog.value = false
      resetUploadForm()
    }

    const resetUploadForm = () => {
      uploadForm.value = {
        sampleName: '',
        sampleNumber: '',
        inspectionStatus: '待检验',
        inspectionType: '',
        sampleStatus: '',
        clientUnit: '',
        inspectedUnit: '',
        manufacturerUnit: '',
        completionDeadline: '',
        partnerCompany: ''
      }
      if (uploadFormRef.value) {
        uploadFormRef.value.resetFields()
      }
    }

    const submitUpload = async () => {
      if (!uploadFormRef.value) return
      
      try {
        const valid = await uploadFormRef.value.validate()
        if (!valid) return
        
        uploading.value = true
        
        const response = await fetch('/api/reports', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(uploadForm.value)
        })

        if (!response.ok) {
          const errorData = await response.json()
          throw new Error(errorData.error || '创建失败')
        }

        const result = await response.json()
        ElMessage.success('报告创建成功')
        showUploadDialog.value = false
        resetUploadForm()
        loadReports() // 重新加载报告列表
      } catch (err) {
        console.error('创建失败:', err)
        ElMessage.error(err.message || '创建失败')
      } finally {
        uploading.value = false
      }
    }

    

    // 编辑报告相关方法
    const editReport = (report) => {
      editForm.value = { ...report }
      showEditDialog.value = true
    }

    const submitEdit = async () => {
      if (!editFormRef.value) return
      
      try {
        const valid = await editFormRef.value.validate()
        if (!valid) return
        
        editing.value = true
        
        const response = await fetch(`/api/reports/${editForm.value.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(editForm.value)
        })

        if (!response.ok) {
          const errorData = await response.json()
          throw new Error(errorData.error || '更新失败')
        }

        ElMessage.success('报告更新成功')
        showEditDialog.value = false
        loadReports()
      } catch (err) {
        console.error('更新失败:', err)
        ElMessage.error(err.message || '更新失败')
      } finally {
        editing.value = false
      }
    }

    const cancelEdit = () => {
      showEditDialog.value = false
    }

    // 上传附件相关方法
    const uploadAttachment = (report) => {
      console.log('开始上传附件，报告信息:', {
        reportId: report.id,
        sampleName: report.sampleName,
        existingAttachment: report.attachment
      })
      
      attachmentForm.value.reportId = report.id
      attachmentForm.value.attachmentFile = null
      uploadProgress.value = 0
      showAttachmentDialog.value = true
      
      // 清空上传组件的文件列表
      if (attachmentUploadRef.value) {
        attachmentUploadRef.value.clearFiles()
      }
    }

    const handleAttachmentChange = (file) => {
      attachmentForm.value.attachmentFile = file.raw
    }

    const handleAttachmentRemove = () => {
      attachmentForm.value.attachmentFile = null
      uploadProgress.value = 0
    }

    const submitAttachment = async () => {
      if (!attachmentForm.value.attachmentFile) {
        ElMessage.error('请选择要上传的文件')
        return
      }
      
      console.log('提交附件上传，参数:', {
        reportId: attachmentForm.value.reportId,
        fileName: attachmentForm.value.attachmentFile.name,
        fileSize: attachmentForm.value.attachmentFile.size
      })
      
      uploadingAttachment.value = true
      uploadProgress.value = 0
      
      try {
        const formData = new FormData()
        formData.append('file', attachmentForm.value.attachmentFile)
        formData.append('reportId', attachmentForm.value.reportId)
        
        // 使用 XMLHttpRequest 来支持上传进度
        const xhr = new XMLHttpRequest()
        
        // 监听上传进度
        xhr.upload.addEventListener('progress', (event) => {
          if (event.lengthComputable) {
            uploadProgress.value = Math.round((event.loaded / event.total) * 100)
          }
        })
        
        // 创建 Promise 来处理 XMLHttpRequest
        const uploadPromise = new Promise((resolve, reject) => {
          xhr.onload = () => {
            if (xhr.status === 200) {
              try {
                const response = JSON.parse(xhr.responseText)
                resolve(response)
              } catch (e) {
                reject(new Error('响应解析失败'))
              }
            } else {
              try {
                const errorData = JSON.parse(xhr.responseText)
                reject(new Error(errorData.error || '上传失败'))
              } catch (e) {
                reject(new Error(`上传失败 (${xhr.status})`))
              }
            }
          }
          
          xhr.onerror = () => {
            reject(new Error('网络错误'))
          }
          
          xhr.open('POST', '/api/upload-attachment')
          xhr.send(formData)
        })
        
        const result = await uploadPromise
        
        console.log('附件上传成功，服务器响应:', result)
        ElMessage.success('附件上传成功')
        showAttachmentDialog.value = false
        resetAttachmentForm()
        loadReports()
      } catch (err) {
        console.error('附件上传失败:', err)
        ElMessage.error(err.message || '上传失败')
      } finally {
        uploadingAttachment.value = false
        uploadProgress.value = 0
      }
    }

    const cancelAttachment = () => {
      showAttachmentDialog.value = false
      resetAttachmentForm()
    }
    
    const resetAttachmentForm = () => {
      attachmentForm.value.reportId = ''
      attachmentForm.value.attachmentFile = null
      uploadProgress.value = 0
      
      // 清空上传组件的文件列表
      if (attachmentUploadRef.value) {
        attachmentUploadRef.value.clearFiles()
      }
    }

    // 生成二维码相关方法
    const generateQRCode = async (report) => {
      qrCodeData.value = null
      showQRCodeDialog.value = true
      
      try {
        // 生成二维码数据（报告详情链接）
        const qrContent = `${window.location.origin}/view/${report.id}`
        
        // 动态导入 qrcode 库
        const QRCode = await import('qrcode')
        
        // 等待DOM更新
        await nextTick()
        
        // 再次等待确保canvas元素完全准备就绪
        setTimeout(async () => {
          try {
            if (qrCodeCanvas.value) {
              await QRCode.toCanvas(qrCodeCanvas.value, qrContent, {
                width: 200,
                margin: 2,
                color: {
                  dark: '#000000',
                  light: '#FFFFFF'
                }
              })
              qrCodeData.value = qrContent
              console.log('二维码生成成功:', qrContent)
            } else {
              console.error('Canvas元素未找到')
              ElMessage.error('二维码生成失败：Canvas元素未找到')
            }
          } catch (err) {
            console.error('二维码生成失败:', err)
            ElMessage.error('二维码生成失败: ' + err.message)
            qrCodeData.value = 'error' // 设置错误状态
          }
        }, 100)
      } catch (error) {
        console.error('二维码生成失败:', error)
        ElMessage.error('二维码生成失败: ' + error.message)
        qrCodeData.value = 'error' // 设置错误状态
      }
    }

    const saveQRCode = () => {
      if (!qrCodeCanvas.value) return
      
      try {
        const canvas = qrCodeCanvas.value
        const link = document.createElement('a')
        link.download = `qrcode_${Date.now()}.png`
        link.href = canvas.toDataURL()
        link.click()
        ElMessage.success('二维码保存成功')
      } catch (error) {
        console.error('保存二维码失败:', error)
        ElMessage.error('保存失败')
      }
    }

    // 删除报告相关方法
    const deleteReport = (report) => {
      deleteTarget.value = report
      showDeleteDialog.value = true
    }

    const confirmDeleteReport = async () => {
      if (!deleteTarget.value) return
      
      try {
        deleting.value = true
        
        const response = await fetch(`/api/reports/${deleteTarget.value.id}`, {
          method: 'DELETE'
        })

        if (!response.ok) {
          const errorData = await response.json()
          throw new Error(errorData.error || '删除失败')
        }

        ElMessage.success('报告删除成功')
        showDeleteDialog.value = false
        deleteTarget.value = null
        loadReports() // 重新加载报告列表
      } catch (err) {
        console.error('删除失败:', err)
        ElMessage.error(err.message || '删除失败')
      } finally {
        deleting.value = false
      }
    }

    

    // 导出数据方法
    const exportData = () => {
      if (filteredReports.value.length === 0) {
        ElMessage.warning('没有数据可以导出')
        return
      }

      // 准备导出数据
      const exportData = filteredReports.value.map(report => {
        // 直接使用COS文件URL
        const reportUrl = report.attachment?.filePath || report.filePath || ''

        return {
          '样品名称': report.sampleName || '',
          '报告编号': report.sampleNumber || '',
          '检验状态': report.inspectionStatus || '',
          '检验类型': report.inspectionType || '',
          '样品状态': report.sampleStatus || '',
          '委托单位': report.clientUnit || '',
          '受检单位': report.inspectedUnit || '',
          '生产单位': report.manufacturerUnit || '',
          '完成期限': report.completionDeadline || '',
          '合作公司': report.partnerCompany || '',
          '报告URL': reportUrl,
          '上传时间': formatUploadTime(report.uploadTime)
        }
      })

      // 转换为CSV格式
      const headers = Object.keys(exportData[0])
      const csvContent = [
        headers.join(','),
        ...exportData.map(row => 
          headers.map(header => {
            const value = row[header] || ''
            // 如果值包含逗号、换行符或双引号，需要用双引号包围并转义
            if (value.includes(',') || value.includes('\n') || value.includes('"')) {
              return `"${value.replace(/"/g, '""')}"`
            }
            return value
          }).join(',')
        )
      ].join('\n')

      // 创建并下载文件
      const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', `报告数据_${new Date().toISOString().slice(0, 10)}.csv`)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)

      ElMessage.success(`成功导出 ${exportData.length} 条数据`)
    }

    // 刷新报告列表
    const refreshReports = async () => {
      console.log('🔄 手动刷新报告列表')
      await loadReports(true)
      ElMessage.success('报告列表已刷新')
    }

    onMounted(() => {
      loadReports(true)
    })

    return {
      reports,
      filteredReports,
      loading,
      showSearchForm,
      searchForm,
      isMobile,
      isDesktop,
      deviceType,
      showDownloadButton,
      uploading,
      editing,
      uploadingAttachment,
      uploadProgress,
      deleting,
      showUploadDialog,
      showEditDialog,
      showAttachmentDialog,
      showQRCodeDialog,
      showDeleteDialog,
      deleteTarget,
      qrCodeData,
      uploadForm,
      editForm,
      attachmentForm,
      uploadRules,
      uploadFormRef,
      editFormRef,
      attachmentFormRef,
      attachmentUploadRef,
      qrCodeCanvas,
      loadReports,
      refreshReports,
      getStatusType,
      formatDeadline,
      formatUploadTime,
      toggleSearchForm,
      handleSearch,
      resetSearch,
      searchReports,
      currentPage,
      pageSize,
      total,
      displayReports,
      handlePageChange,
      handlePageSizeChange,
      loadMore,
      hasMore,
      cancelUpload,
      submitUpload,
      editReport,
      submitEdit,
      cancelEdit,
      uploadAttachment,
      handleAttachmentChange,
      handleAttachmentRemove,
      submitAttachment,
      cancelAttachment,
      generateQRCode,
      saveQRCode,
      deleteReport,
      confirmDeleteReport,
      exportData,
      handleDownloadButtonVisibilityChange,
      Loading
    }
  }
}
</script>

<style scoped>
.report-list-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .report-list-container {
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .report-list-container {
    padding: 5px;
  }
}

/* 页面头部样式 */
.page-header {
  background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
  color: white;
  padding: 40px 30px;
  border-radius: 12px;
  margin-bottom: 20px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.page-header h1 {
  margin: 0 0 10px 0;
  font-size: 28px;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.page-header p {
  margin: 0;
  font-size: 16px;
  opacity: 0.9;
}

/* 查询卡片样式 */
.search-card {
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.search-form {
  padding: 10px 0;
}

.search-form .el-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.search-form .el-form-item {
  margin-bottom: 15px;
  margin-right: 20px;
}

.search-form .el-form-item:last-child {
  margin-right: 0;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.empty-state {
  padding: 40px 20px;
  text-align: center;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.el-table {
  font-size: 14px;
}

.el-table .el-button {
  margin-right: 8px;
}

.el-table .el-button:last-child {
  margin-right: 0;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-upload__tip {
  color: #909399;
  font-size: 12px;
  margin-top: 8px;
}

/* 表格样式优化 */
:deep(.el-table th) {
  background-color: #f5f7fa;
  font-weight: 600;
}

:deep(.el-table td) {
  padding: 12px 0;
}

:deep(.el-table .el-button--small) {
  padding: 5px 10px;
  font-size: 12px;
}

/* 状态标签样式 */
:deep(.el-tag) {
  font-size: 12px;
  padding: 2px 8px;
}

/* 对话框样式 */
:deep(.el-dialog__header) {
  padding: 20px 20px 10px;
}

:deep(.el-dialog__body) {
  padding: 10px 20px;
}

:deep(.el-dialog__footer) {
  padding: 10px 20px 20px;
}

/* 表单样式 */
:deep(.el-form-item__label) {
  font-weight: 500;
}

:deep(.el-input__wrapper) {
  border-radius: 4px;
}

:deep(.el-select) {
  width: 100%;
}

/* 上传组件样式 */
:deep(.el-upload) {
  width: 100%;
}

:deep(.el-upload-dragger) {
  width: 100%;
}

/* 二维码样式 */
.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.qr-code-display {
  text-align: center;
}

.qr-code-info {
  margin-top: 15px;
  color: #606266;
  font-size: 14px;
}

.qr-code-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #606266;
  padding: 40px 20px;
}

.qr-code-loading .el-icon {
  font-size: 24px;
  margin-bottom: 10px;
}

.qr-code-loading p {
  margin: 0;
  font-size: 14px;
}

/* 预览弹框样式 */
.preview-content {
  padding: 20px;
}

.report-info {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.report-info h3 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 20px;
  font-weight: 600;
}

.report-info p {
  margin: 8px 0;
  color: #606266;
  font-size: 14px;
  line-height: 1.6;
}

.report-info strong {
  color: #303133;
  font-weight: 600;
  margin-right: 8px;
}

.report-file {
  border-top: 1px solid #e4e7ed;
  padding-top: 20px;
}

.report-file h4 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.file-actions {
  display: flex;
  gap: 10px;
}

.file-actions .el-button {
  flex: 1;
}

.report-attachments {
  border-top: 1px solid #e4e7ed;
  padding-top: 20px;
  margin-top: 20px;
}

.report-attachments h4 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.attachment-item {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
}

.attachment-item:last-child {
  margin-bottom: 0;
}

.attachment-info {
  margin-bottom: 15px;
}

.attachment-info p {
  margin: 5px 0;
  font-size: 14px;
  line-height: 1.5;
}

/* PC端和移动端显示控制 */
/* 移除媒体查询，现在使用JavaScript控制显示 */

/* 移动端卡片布局样式 */
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 16px;
}

.report-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin: 0 0 16px 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e4e7ed;
  transition: box-shadow 0.3s ease;
}

.report-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.card-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.report-title h3 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}

.sample-number {
  font-size: 12px;
  color: #909399;
  background: #f5f7fa;
  padding: 2px 8px;
  border-radius: 4px;
}

.card-content {
  margin-bottom: 16px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #f8f9fa;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row .label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
  min-width: 70px;
}

.info-row .value {
  font-size: 13px;
  color: #303133;
  text-align: right;
  flex: 1;
  margin-left: 10px;
  word-break: break-all;
}

.card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-start;
}

.card-actions .el-button {
  flex: 0 0 auto;
  min-width: 60px;
  font-size: 12px;
  padding: 6px 12px;
}

/* 响应式表单样式 */
.responsive-form {
  width: 100%;
}

@media (max-width: 768px) {
  .responsive-form .el-form-item {
    display: block;
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 16px;
  }
  
  .responsive-form .el-form-item__label {
    display: block;
    width: 100% !important;
    text-align: left !important;
    margin-bottom: 6px;
    font-weight: 500;
  }
  
  .responsive-form .el-form-item__content {
    margin-left: 0 !important;
    width: 100%;
  }
  
  .form-actions {
    text-align: center;
  }
  
  .form-actions .el-button {
    margin: 4px;
  }
}

/* 卡片头部响应式 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .card-header {
    flex-direction: column;
    align-items: stretch;
  }
  
  .header-actions {
    justify-content: center;
  }
  
  .search-card .card-header {
    flex-direction: row;
    align-items: center;
  }
}

/* 对话框移动端适配 */
@media (max-width: 768px) {
  :deep(.el-dialog) {
    width: 95% !important;
    margin: 0 auto;
  }
  
  :deep(.el-dialog__body) {
    padding: 15px;
  }
  
  :deep(.el-form-item__label) {
    width: 100px !important;
  }
}

@media (max-width: 768px) {
  .mobile-card-list {
    padding: 0 12px;
    gap: 16px;
  }
  
  .report-card {
    margin: 0 0 12px 0;
    padding: 16px;
  }
}

@media (max-width: 480px) {
  :deep(.el-dialog) {
    width: 98% !important;
  }
  
  :deep(.el-form-item__label) {
    width: 80px !important;
    font-size: 13px;
  }
  
  .mobile-card-list {
    padding: 0 8px;
    gap: 12px;
  }
  
  .card-actions .el-button {
    min-width: 50px;
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .report-card {
    padding: 14px;
    margin: 0 0 8px 0;
    border-radius: 8px;
  }
  
  .card-header-mobile {
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
  
  .report-title h3 {
    font-size: 14px;
  }
  
  .info-row .label,
  .info-row .value {
    font-size: 12px;
  }
}

/* 分页样式 */
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

/* 加载更多按钮样式 */
.load-more-container {
  margin-top: 20px;
  text-align: center;
  padding: 20px 0;
}

.load-more-container .el-button {
  width: 200px;
  height: 40px;
}

/* 上传进度条样式 */
.upload-status {
  margin-top: 8px;
  font-size: 14px;
  color: #606266;
  text-align: center;
}

.el-progress {
  margin-bottom: 8px;
}

.el-progress__text {
  font-weight: 600;
}

@media (max-width: 480px) {
  .pagination-container {
    margin-top: 15px;
  }
  
  .load-more-container {
    margin-top: 15px;
    padding: 15px 0;
  }
  
  .load-more-container .el-button {
    width: 150px;
    height: 36px;
  }
  
  .upload-status {
    font-size: 12px;
  }
}
</style>